
import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X, Home } from "lucide-react";
import ThemeToggle from "./ThemeToggle";


const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: "Accueil", href: "/", icon: Home, isIcon: true },
    { name: "Notre Vision", href: "/a-propos" },
    { name: "Mon Bilan", href: "/evaluation" },
    { name: "Ma prévention", href: "/ma-prevention" },
  ];

  const isActiveRoute = (href: string) => {
    return location.pathname === href;
  };

  

  return (
    <header className="fixed top-0 left-0 right-0 feel-gradient-bg shadow-sm z-50 border-b border-white/20">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo texte */}
          <Link to="/" className="text-white font-bold text-xl tracking-wider">
            FEEL
          </Link>

          {/* Navigation Desktop */}
          <nav className="hidden md:flex items-center space-x-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-sm font-medium transition-colors hover:text-white/80 flex items-center ${
                  isActiveRoute(item.href)
                    ? "text-white border-b-2 border-white pb-1"
                    : "text-white/90"
                }`}
              >
                {item.isIcon && item.icon ? (
                  <item.icon className="w-5 h-5" />
                ) : (
                  item.name
                )}
              </Link>
            ))}
          </nav>

          {/* Actions Desktop */}
          <div className="hidden md:flex items-center space-x-3">
            <ThemeToggle />
            <Button asChild className="bg-white text-feel-bleu-vif hover:bg-white/90 border-0 shadow-lg">
              <Link to="/evaluation">
                Commencer mon bilan
              </Link>
            </Button>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-2">
            <ThemeToggle />
            <button
              className="p-2 text-white"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden absolute top-16 left-0 right-0 bg-card border-b shadow-lg backdrop-blur-md">
            <nav className="px-4 py-4 space-y-4">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  className={`block text-sm font-medium transition-colors hover:text-accent flex items-center gap-2 ${
                    isActiveRoute(item.href) ? "text-primary" : "text-foreground"
                  }`}
                  onClick={() => setIsMenuOpen(false)}
                >
                  {item.isIcon && item.icon ? (
                    <>
                      <item.icon className="w-4 h-4" />
                      <span>Accueil</span>
                    </>
                  ) : (
                    item.name
                  )}
                </Link>
              ))}
              
              
              <Button asChild className="w-full feel-gradient text-white mt-4">
                <Link to="/evaluation" onClick={() => setIsMenuOpen(false)}>
                  Commencer mon bilan
                </Link>
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
